/**
 * @author: dongjing
 * @file: description
 * @Date: 2019-12-02 12:03:03
 * @LastEditors: dongjing
 * @LastEditTime: 2019-12-09 21:31:41
 */
import commonActions from '@features/common/redux/actions';
import messageActions from '@features/message/redux/actions';
import articlesActions from '@features/articles/redux/actions';
import askActions from '@features/ask/redux/actions';
import { default as doHomeModel } from './homeModel';
import { default as doAppModel } from './appModel';

const actions = {
  ...commonActions,
  ...messageActions,
  ...articlesActions,
  ...askActions,
  ...doHomeModel.actions,
  ...doAppModel.actions
};

export default actions;
